"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithLoader = exports.withLoaderHoc = void 0;

var react_1 = __importStar(require("react"));

var Hoc = __importStar(require("../hoc"));

var ui_1 = require("../ui");

var withLoaderPromise = Hoc.Data.Load.withLoaderPromise;

exports.withLoaderHoc = function (Component, promise) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function () {
    return withLoaderPromise(Component, ui_1.Loader, promise)(props);
  };
};

exports.WithLoader = function (props) {
  var _react_1$useState = react_1.useState(null),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      data = _react_1$useState2[0],
      setData = _react_1$useState2[1];

  var Component = props.Component,
      dataLoad = props.dataLoad;
  react_1.default.useEffect(function () {
    setData(null);
  }, [props.dataLoad]);

  if (data === null) {
    dataLoad.then(function (x) {
      setData(x);
    }).catch(function (err) {
      console.log(err);
    });
    return react_1.default.createElement(ui_1.Loader, null);
  }

  return react_1.default.createElement(Component, Object.assign({
    data: data
  }, props));
};

exports.default = function (Component, promise) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return withLoaderPromise(Component, ui_1.Loader, promise)(props);
};